const dummyUnmask = (willValidate = true) => function (maskedValue, unmaskedValue) {
    if (!willValidate || this.isValid(maskedValue)) {
        return maskedValue
    }

    return false
}

Inputmask.extendAliases({
    userTag: {
        mask: ['XXX'],
        definitions: {
            'X': {
                validator: '[a-zA-Z]',
                cardinality: 1,
                casing: 'upper'
            }
        },
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    maskedIp: {
        mask: 'i[i[i]].i[i[i]].i[i[i]].i[i[i]]',
        definitions: {
            'i': {
                validator: function (chrs, maskset, pos, strict, opts) {
                    if (pos - 1 > -1 && maskset.buffer[pos - 1] !== '.') {
                        chrs = maskset.buffer[pos - 1] + chrs
                        if (pos - 2 > -1 && maskset.buffer[pos - 2] !== '.') {
                            chrs = maskset.buffer[pos - 2] + chrs
                        } else chrs = '0' + chrs
                    } else chrs = '00' + chrs

                    return new RegExp('25[0-5]|2[0-4][0-9]|[01][0-9][0-9]|00\\*').test(chrs)
                },
                cardinality: 1
            }
        },
        onUnMask: function (maskedValue, unmaskedValue, opts) {
            return maskedValue
        },
        inputmode: 'numeric'
    },
    rg: {
        mask: ['99.999.999-X', '999.999.999-X'],
        definitions: {
            'X': {
                validator: '[a-zA-Z0-9]',
                cardinality: 1,
                casing: 'upper'
            }
        },
        onUnMask: dummyUnmask()
    },
    rg2: {
        mask: ['99.999.999-X', '999.999.999-X', '999.999-X'],
        definitions: {
            'X': {
                validator: '[a-zA-Z0-9]',
                cardinality: 1,
                casing: 'upper'
            }
        },
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    cpf: {
        mask: '999.999.999-99',
        onUnMask: dummyUnmask()
    },
    cnpj: {
        mask: '99.999.999/9999-99',
        onUnMask: dummyUnmask()
    },
    cep: {
        mask: '99999-999',
        onUnMask: dummyUnmask()
    },
    creciNatural: {
        regex: '[0-9]+-F',
        onUnMask: dummyUnmask()
    },
    simplePercentage: {
        groupSeparator: '.',
        radixPoint: ',',
        alias: 'numeric',
        autoGroup: !0,
        digits: 10,
        digitsOptional: true,
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        max: 100,
        min: 0,
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    money: {
        groupSeparator: '.',
        radixPoint: ',',
        alias: 'numeric',
        autoGroup: true,
        digits: 2,
        max: 1000000000000,
        digitsOptional: true,
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    meters: {
        groupSeparator: '.',
        radixPoint: ',',
        alias: 'numeric',
        autoGroup: !0,
        digits: 2,
        digitsOptional: true,
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    squareMeters: {
        groupSeparator: '.',
        radixPoint: ',',
        alias: 'numeric',
        autoGroup: true,
        digits: 2,
        digitsOptional: true,
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    double: {
        groupSeparator: '.',
        radixPoint: ',',
        alias: 'numeric',
        autoGroup: true,
        digits: 2,
        digitsOptional: true,
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        onUnMask: function (maskedValue, unmaskedValue) {
            return unmaskedValue
        }
    },
    br_phones: {
        mask: ['99 9999[9]-9999', '99\\*9{1,7}\\*9{2,5}'],
        clearMaskOnLostFocus: true,
        onUnMask: function (maskedValued, unmaskedValue) {
            return maskedValued.replace(/[^0-9\*]/g, '')
        }
    },
    br_phone: {
        mask: '99 9999[9]-9999'
    },
    nextel: {
        mask: '99\\*9{1,7}\\*9{2,5}'
    },
    validUrl: {
        alias: 'Regex',
        regex: '[a-zA-Z0-9_\-]+'
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/inputmask-local-masks.js